/**
 * Vuex mutations for the prism module.
 *
 * @module store/modules/prism/mutations
 * @description Currently no mutations defined. State is primarily read-only.
 */
import { MutationTree } from "vuex/types";

import { PrismState } from "./types";

const mutations: MutationTree<PrismState> = {};

export default mutations;
